// extracted by mini-css-extract-plugin
export default {"container":"YfwJR1","glitch":"TrDM_j","text":"UsRQwP","without-scope":"za31B4","withoutScope":"za31B4","block":"v7hKvY"};